import { ActionType } from "../../../../../../../../react-core/Flux/ActionType";
import { BaseStore } from "../../../../../../../../react-core/Flux/BaseStore";
import { AccountTransfersCollection } from "../../../../../../../../Wrap/Models/Domains/Transactions/AccountTransfers/AccountTransfersCollection";
import { CashTransactionCollection } from "../../../../../../../../Wrap/Models/Domains/Transactions/CashTransactionCollection";
import { ChargesTransaction } from "../../../../../../../../Wrap/Models/Domains/Transactions/Charges/ChargesTransaction";
import { CorporateActionsCollection } from "../../../../../../../../Wrap/Models/Domains/Transactions/CorporateAction/CorporateActionsCollection";
import { InvestmentTransactionCollection } from "../../../../../../../../Wrap/Models/Domains/Transactions/Investments/InvestmentTransactionCollection";
import { TransactionSummarryCollection } from "../../../../../../../../Wrap/Models/Domains/Transactions/Summary/TransactionSummarryCollection";
import { CashPayment } from "../../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Payment/CashPayment";
import { TransactionEnum } from "../Resource/Contents";

import { TransactionDispatcher } from "./Variable";

export interface TransactionStaticState {
    isLoading?: boolean;
    actionType: ActionType;
    data?: {
        [TransactionEnum.summary]: TransactionSummarryCollection;
        [TransactionEnum.accountTransfers]: AccountTransfersCollection;
        [TransactionEnum.corporateActions]: CorporateActionsCollection;
        [TransactionEnum.investments]: InvestmentTransactionCollection;
        [TransactionEnum.cash]: CashTransactionCollection;
        [TransactionEnum.otherCorporateActions]: CorporateActionsCollection;
        [TransactionEnum.paymentsWithdrawals]: CashPayment[];
        [TransactionEnum.charges]: ChargesTransaction[];
    };
}

export class TransactionStatic extends BaseStore<TransactionStaticState> {
    constructor() {
        super();
        this.subscribeToDispatcher(TransactionDispatcher, (actionData) => this.onTransactionStoreResponse(actionData));
    }

    public getLastResult(): TransactionStaticState {
        return this.getState();
    }

    public isLoading(): boolean {
        return this.getState().isLoading;
    }

    public getData() {
        return this.getState().data;
    }

    public getActionType() {
        return this.getState().actionType;
    }

    protected getDefaultState(): TransactionStaticState {
        return { actionType: ActionType.Loading, data: null };
    }

    private onTransactionStoreResponse(actionData): void {
        switch (actionData.actionType) {
            case ActionType.Success:
                this.setState({ actionType: actionData.actionType, data: actionData.payload });
                break;
            case ActionType.Error:
                this.setState({ actionType: actionData.actionType });
                break;
            case ActionType.Loading:
                this.setState({ actionType: actionData.actionType });
                break;
        }
    }
}
